import { Environment } from '@classifieds-sell/environment';

export const environment: Environment = {
    production: false,
    apiUrl: `${window.location.origin}/vehicles/api`,
    appBaseHref: '/sell/vehicles/',
    authUrl: 'https://test.auth.trademe.co.nz/',
    frontendUrl: `${window.location.origin}/sell/vehicles`,
    apiBaseUrlForGringotts: 'https://api.test2h.trademe.co.nz/',
    paymentWidgetUrl: 'https://stable.test.ping.trademe.co.nz',
    trademeUrl: 'https://www.test2h.trademe.co.nz/',
    tagManagerId: 'GTM-5ZFBB63',
    authClientId: 'motors_sell',
    authScope: 'openid profile email BoatSellApi.Read BoatSellApi.Write'
};
